import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { NotificationsService } from '../../shared/components/notifications/service/notifications.service';

@Injectable({ providedIn: 'root' })
export class InactivityService {
  private readonly defaultTimeoutMs = 15 * 60 * 1000; // 15 minutos
  private timeoutMs = this.defaultTimeoutMs;
  private timeoutId: any = null;
  private isMonitoring = false;

  private readonly isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
  private readonly events: string[] = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll'];
  private readonly boundReset = this.resetTimer.bind(this);

  constructor(
    private authService: AuthService,
    private router: Router,
    private notifications: NotificationsService
  ) {}

  startMonitoring(timeoutMs?: number): void {
    if (!this.isBrowser) {
      return;
    }
    if (typeof timeoutMs === 'number' && timeoutMs > 0) {
      this.timeoutMs = timeoutMs;
    } else {
      this.timeoutMs = this.defaultTimeoutMs;
    }

    if (this.isMonitoring) {
      this.stopMonitoring();
    }

    this.events.forEach(evt => document.addEventListener(evt, this.boundReset, true));
    this.isMonitoring = true;
    this.resetTimer();
  }

  stopMonitoring(): void {
    if (!this.isBrowser) {
      return;
    }
    this.events.forEach(evt => document.removeEventListener(evt, this.boundReset, true));
    this.isMonitoring = false;
    this.clearTimer();
  }

  private clearTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private resetTimer(): void {
    // Solo aplica si el usuario está logueado
    if (!this.authService.isLoggedIn()) {
      this.clearTimer();
      return;
    }
    this.clearTimer();
    this.timeoutId = setTimeout(() => this.handleInactivity(), this.timeoutMs);
  }

  private handleInactivity(): void {
    // Cerrar sesión por inactividad
    this.authService.autoCloseSession();
    // Avisar al usuario
    this.notifications.addNotification({
      message: 'Sesión cerrada por inactividad',
      type: 'warning',
      autoClose: true,
      duration: 5000
    });
    // Redirigir al login
    this.router.navigate(['/auth/login']);
    // Detener monitoreo hasta que haya nueva interacción
    this.stopMonitoring();
  }
}